module.exports = __webpack_public_path__ + "static/media/glanum_strasse.9f659a98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_strasse.png
// module id = 267
// module chunks = 0